// extracted by mini-css-extract-plugin
export var backupIcon = "_sj-1";
export var image = "_sj-0";